/*
 * Copyright © 2026 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

// pcg-core: display formatting helpers (core-viewer.js 3290-3301, 4014-4017).
// escapeHtml (3302-3306) intentionally NOT vendored — HTML escaping belongs to the
// React layer, which does not build HTML strings.

export function fmtMs(v) {
  if (v === undefined || v === null || v === "-" || Number.isNaN(Number(v))) return "-"
  return Number(v).toFixed(0)
}

export function fmtNumber(v, digits) {
  if (v === undefined || v === null || v === "-" || Number.isNaN(Number(v))) return "-"
  return Number(v).toFixed(digits)
}

export function fmtSegment(segment) {
  if (!segment || !isFinite(segment.duration)) return "selected segment"
  return `${fmtNumber(segment.duration, 1)}s segment (${fmtNumber(segment.start, 1)}-${fmtNumber(segment.end, 1)}s)`
}

export function pctLabel(v) {
  if (!Number.isFinite(Number(v))) return "-"
  return `${fmtNumber(Number(v) * 100, 0)}%`
}
